var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "screen" }, [
    _c("div", { staticClass: "screen__line" }, [
      _c("img", { attrs: { src: _vm.quizBlueLine, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "screen__inner" }, [
      _c("h3", { staticClass: "screen__header heading-tertiary" }, [
        _vm._v(_vm._s(_vm.question)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "screen__counter" }, [
        _c("p", { staticClass: "screen__text heading-tertiary" }, [
          _c("span", { staticClass: "current-page" }, [
            _vm._v(_vm._s(_vm.currentPage)),
          ]),
          _vm._v("\n                 "),
          _c("span", { staticClass: "total-pages" }, [
            _vm._v(" /" + _vm._s(_vm.totalPages)),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "screen__form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.handleSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "screen__form-flex" }, [
          _c(
            "div",
            { staticClass: "screen__form-column" },
            _vm._l(_vm.answers, function (answer, index) {
              return _c(
                "label",
                { key: index, staticClass: "screen__label custom-checkbox" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedAnswers,
                        expression: "selectedAnswers",
                      },
                    ],
                    staticClass: "screen__checkbox",
                    attrs: { type: "checkbox" },
                    domProps: {
                      value: answer,
                      checked: Array.isArray(_vm.selectedAnswers)
                        ? _vm._i(_vm.selectedAnswers, answer) > -1
                        : _vm.selectedAnswers,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.selectedAnswers,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = answer,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selectedAnswers = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedAnswers = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedAnswers = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "screen__answer paragraph-primary" }, [
                    _vm._v(_vm._s(_vm.$t(answer))),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "screen__buttons" }, [
          _c(
            "button",
            {
              staticClass: "screen__button btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.handleBack },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("__quiz_button_back")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "screen__button btn btn-primary",
              class: { "screen__button--disabled": !_vm.isNextButtonActive },
              attrs: { type: "submit", disabled: !_vm.isNextButtonActive },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("__quiz_button_next")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "screen__background" }, [
      _c("img", { attrs: { src: _vm.questionIcon, alt: "" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }